import Vue from 'vue';

export default {

  async fetchRoles({ commit }) {
    return Vue.axios.get(Vue.$url("role"))
      .then((rsp) => {
        Vue.$log.debug("roles list", rsp.data)
        commit("SET_ROLES", rsp.data)
      })
  },


}